// extracted by mini-css-extract-plugin
export default {"maxSize":"Image_maxSize__ODW-G","smallSize":"Image_smallSize__fLmhh","max":"Image_max__f3WiA","small":"Image_small__ZtfU3"};